module.exports = __webpack_public_path__ + "static/media/parity.4e96e605.png";